










































import Vue from 'vue';
import NavBar from '~mall/components/NavBar';
import { isHelloFamilyApp } from '~mall/common/env/env';

export default Vue.extend({
  name: 'SlidePopUp',
  components: {
    NavBar,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    getContainer: {
      type: String,
      default: '',
    },
    componentParams: {
      type: Object,
      default: () => ({}),
    },
    hideDefaultCloseIcon: {
      type: Boolean,
      default: false,
    },
    defaultFullScreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fullScreen: this.defaultFullScreen,
      isShow: false,
      targetElement: null as HTMLElement | null,
      getRef: (() => {}) as (el: HTMLElement) => void,
      hideCloseIcon: false,
      showNavBar: false,
      isHelloFamilyApp,
    };
  },
  computed: {
    container(): HTMLElement {
      if (!this.getContainer) {
        return document.body;
      }
      const element = document.querySelector(this.getContainer);
      return element instanceof HTMLElement ? element : document.body;
    },
  },
  watch: {
    show: {
      handler(newVal: boolean) {
        if (newVal) {
          // 禁止body html滚动
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
          this.hideCloseIcon = false;
          setTimeout(() => {
            this.isShow = true;
          }, 200);
        } else {
          this.isShow = false;
          // 恢复滚动：移除 overflow 样式而不是设置为 auto
          document.documentElement.style.removeProperty('overflow');
          document.body.style.removeProperty('overflow');
        }
      },
      immediate: true,
    },
    defaultFullScreen: {
      handler(newVal: boolean) {
        this.fullScreen = newVal;
        if (newVal) {
          this.showNavBar = true;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.targetElement = this.container;
    if (this.show && this.$el.parentNode) {
      this.targetElement.appendChild(this.$el);
    }
  },
  updated() {
    if (
      this.show
        && this.targetElement
        && this.$el.parentNode !== this.targetElement
    ) {
      this.targetElement.appendChild(this.$el);
    }
  },
  beforeDestroy() {
    if (this.$el.parentNode === this.targetElement) {
      document.body.appendChild(this.$el);
    }
  },
  methods: {
    handleClose() {
      if (this.fullScreen) {
        this.$router.back();
        this.$emit('close');
        return;
      }
      // nativeMgr.hideNaviBar(false);
      this.showNavBar = false;
      this.hideCloseIcon = true;
      this.fullScreen = false;
      this.isShow = false;
      this.$emit('close');
    },
    handleClickOverlay() {
      this.isShow = false;
      // nativeMgr.hideNaviBar(false);
      this.showNavBar = false;
      this.$emit('click-overlay');
    },
  },
});
